/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./forwardToThirdParty.vue?vue&type=template&id=aca5a8a4&scoped=true"
import script from "./forwardToThirdParty.vue?vue&type=script&lang=js"
export * from "./forwardToThirdParty.vue?vue&type=script&lang=js"
import style0 from "./forwardToThirdParty.vue?vue&type=style&index=0&id=aca5a8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca5a8a4",
  null
  
)

export default component.exports